import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, Loader2Icon } from 'lucide-react';
type Status = 'idle' | 'loading' | 'success' | 'error';
export function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus('error');
      return;
    }
    setStatus('loading');
    window.setTimeout(() => setStatus('success'), 900);
  };
  return <div className="flex h-full flex-col rounded-[2rem] bg-sand p-8 md:p-10" data-id="element-267" data-mp="3jpmz2org4vm9">
      <h3 className="font-display text-3xl uppercase text-ink md:text-4xl" data-id="element-268" data-mp="3nrrr5j28xk6s">Stay in the loop</h3>
      <p className="mt-2 text-ink/75" data-id="element-269" data-mp="yzxk8bqqt9tk">Events, business spotlights, and ways to show up for the community.</p>

      <AnimatePresence mode="wait" initial={false} data-id="element-270" data-mp="13194e1qul2ud">
        {status === 'success' ? <motion.div key="success" initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-auto flex items-center gap-3 rounded-2xl bg-catracho p-5 text-sand" role="status" data-id="element-271" data-mp="h554d0b1tj1i">
            <CheckCircle2Icon size={24} className="shrink-0 text-sun" data-id="element-272" data-mp="35485y5qazsd" />
            <p className="font-bold" data-id="element-273" data-mp="3ucqclt09v6aa">¡Gracias! You're on the list.</p>
          </motion.div> : <motion.form key="form" onSubmit={handleSubmit} noValidate initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15
      }} className="mt-8 lg:mt-auto" data-id="element-274" data-mp="3pk6sseazrex1">
            <label htmlFor="email" className="text-sm font-bold text-ink" data-id="element-275" data-mp="3bknx4kzd9w1m">
              Email address
            </label>
            <input id="email" type="email" value={email} onChange={e => {
          setEmail(e.target.value);
          if (status === 'error') setStatus('idle');
        }} placeholder="you@email.com" aria-invalid={status === 'error'} aria-describedby={status === 'error' ? 'email-error' : undefined} className={`mt-2 w-full rounded-full border-2 bg-sand px-5 py-3.5 text-ink placeholder:text-ink/40 focus:outline-none focus:ring-4 focus:ring-sunset/30 ${status === 'error' ? 'border-flamingo' : 'border-ink/15 focus:border-sunset'}`} data-id="element-276" data-mp="36ogmiew0zwdc" />
            {status === 'error' && <p id="email-error" className="mt-2 text-sm font-bold text-flamingo" data-id="element-277" data-mp="3ax82imnveqjw">
                Please enter a valid email address.
              </p>}
            <button type="submit" disabled={status === 'loading'} className="mt-3 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-sunset px-7 py-3.5 font-bold text-ink transition-[transform,background-color,color] duration-150 ease-out hover:bg-flamingo hover:text-sand active:scale-[0.97] disabled:opacity-70" data-id="element-278" data-mp="78wmyvvkbfnt">
              {status === 'loading' && <Loader2Icon size={18} className="animate-spin" data-id="element-279" data-mp="1wrd1aemjdacc" />}
              {status === 'loading' ? 'Joining…' : 'Sign Me Up'}
            </button>
          </motion.form>}
      </AnimatePresence>
    </div>;
}